import {Injectable, inject, DestroyRef} from '@angular/core';
import {translate} from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {Constants} from 'src/app/models/constants';
import {Instance} from 'src/app/models/instance/instance';
import {getDiffDays} from './utils';

@Injectable({
  providedIn: 'root'
})
export class TrialStatusService  {

  constructor() {
    
  }

  /**
   * Prepares the trial status label to be displayed
   */
  getTrialStatus(demoInstance: Instance): string {
    const expiresOn = !demoInstance.expirationDate ? this.getExpirationDate(demoInstance.dateCreated) : demoInstance.expirationDate;
    const remainingDays = getDiffDays(new Date(), expiresOn);
    let label;

    if (remainingDays <= 0) {
      label = translate('SERVICE.TRIAL_EXPIRED');
    } else {
      label = translate('SERVICE.TRIAL_EXPIRES') + ' ' + remainingDays + ' ';
      label += remainingDays > 1 ? translate('SERVICE.TRIAL_EXPIRES_DAYS') : translate('SERVICE.TRIAL_EXPIRES_DAY');
    }

    return label;
  }

  /**
   * Calculates the expiration date based on the created date
   *
   * @param dateCreated - the start date to be used for expiration date calculation purposes
   * @returns the expiration date
   */
  private getExpirationDate(dateCreated: Date): Date {
    const created = new Date(dateCreated);
    return new Date(created.setDate(created.getDate() + Constants.SERVICE_EXPIRATION_DAYS));
  }
}
